import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const ClientPolicyPage = lazy(() => import('./ClientPolicyPage'));

/**
 * `workspaces:edit`, not an invented `attendance:manage`: the three endpoints
 * behind this page are gated `workspaces.manage` server-side, and
 * SERVER_PERM_ACTIONS maps that server permission onto `workspaces:edit` (among
 * others). Gating the UI on anything else would let the nav show for people the
 * API then 403s.
 */
export const clientPolicyRoutes: RouteObject[] = [
  {
    path: 'client-policy',
    element: (
      <ProtectedRoute action="workspaces:edit">
        <ClientPolicyPage />
      </ProtectedRoute>
    ),
  },
];
